import { shopCall, errorExtras } from '../shop-shared/transport';
import type { AddToCartResult, ShopProductInitData } from './types';

export { errorExtras };

export interface AddToCartPayload {
    product_id: number;
    shop_product_id?: number | null;
    product_type: string;
    variante_id: number | string;
    quantity: number;
    invitation_token?: string;
    /** Name Your Price : montant choisi par le client (re-borné côté serveur). */
    name_your_price_amount?: number;
    /** M2/M6 — variante e-commerce physique (colonne shop_variant_id). */
    shop_variant_id?: number;
}

export function addToCart(init: ShopProductInitData, payload: AddToCartPayload): Promise<AddToCartResult> {
    return shopCall<AddToCartResult>(init, 'gas_add_to_cart', { ...payload });
}

export function emptyCart(init: ShopProductInitData): Promise<unknown> {
    return shopCall(init, 'gas_empty_cart', {});
}
